export default __webpack_public_path__ + "static/media/Frame85.a6878f01.png";